// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import loading01Icon from "@/assets/icons/loading-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Loading01IconProps = Omit<IconProps, "name">;

export function Loading01Icon(props: Loading01IconProps): React.ReactNode {
  return <Icon name={loading01Icon} {...props} />;
}
